import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const CrossPlus: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_31227)'>
        <path
          d='M18.5194 15.5699C18.4545 15.4492 18.3598 15.3487 18.2452 15.2788C18.1305 15.2088 18 15.1719 17.8671 15.1719C17.7341 15.1718 17.6036 15.2087 17.4889 15.2786C17.3742 15.3485 17.2795 15.4489 17.2146 15.5696L14.8745 20.185C14.8195 20.2998 14.7937 20.4274 14.7997 20.5555C14.8057 20.6836 14.8432 20.808 14.9087 20.9167C14.9742 21.0253 15.0655 21.1147 15.1737 21.1761C15.282 21.2376 15.4036 21.2691 15.527 21.2676H20.207C20.3303 21.2691 20.4519 21.2376 20.5602 21.1761C20.6685 21.1147 20.7597 21.0253 20.8252 20.9166C20.8907 20.808 20.9283 20.6836 20.9342 20.5555C20.9402 20.4273 20.9144 20.2998 20.8594 20.185L18.5194 15.5699ZM20.207 20.5049L15.5234 20.541L17.8705 15.9255C17.8705 15.9255 20.2138 20.5042 20.207 20.5049Z'
          fill='url(#paint0_linear_12280_31227)'
          stroke='url(#paint1_linear_12280_31227)'
          strokeWidth='0.5'
        />
        <path
          d='M7.55744 15.5021L5.21851 17.9345L4.71291 17.4087C4.5057 17.199 4.2274 17.0825 3.93824 17.0845C3.64909 17.0866 3.37233 17.2069 3.16786 17.4196C2.9634 17.6322 2.84767 17.9201 2.84573 18.2208C2.84378 18.5215 2.95578 18.8109 3.15747 19.0264L4.44078 20.3611C4.6477 20.5743 4.92721 20.694 5.21852 20.694C5.50982 20.694 5.78933 20.5743 5.99625 20.3611L9.11292 17.1197C9.31548 16.9044 9.4282 16.6147 9.42662 16.3135C9.42504 16.0123 9.30928 15.7238 9.10447 15.5108C8.89966 15.2978 8.62233 15.1774 8.33269 15.1758C8.04305 15.1742 7.76447 15.2914 7.55744 15.5021ZM8.59441 16.5805L5.47774 19.8218C5.40783 19.891 5.31501 19.9296 5.2185 19.9296C5.12198 19.9296 5.02916 19.891 4.95925 19.8218L3.67592 18.4872C3.60788 18.4155 3.56986 18.3188 3.57017 18.2181C3.57048 18.1173 3.60908 18.0209 3.67756 17.9496C3.74603 17.8784 3.83881 17.8383 3.93565 17.838C4.03248 17.8377 4.12551 17.8772 4.19441 17.948L4.95928 18.7434C4.99331 18.7788 5.03373 18.8069 5.07821 18.8261C5.12269 18.8452 5.17037 18.8551 5.21852 18.8551C5.26667 18.8551 5.31435 18.8452 5.35883 18.8261C5.40331 18.8069 5.44373 18.7788 5.47776 18.7434L8.07594 16.0413C8.1452 15.9724 8.23765 15.9344 8.33351 15.9355C8.42936 15.9366 8.521 15.9767 8.58878 16.0472C8.65656 16.1176 8.69511 16.2129 8.69616 16.3126C8.69721 16.4123 8.66069 16.5085 8.59441 16.5805Z'
          fill='url(#paint2_linear_12280_31227)'
          stroke='url(#paint3_linear_12280_31227)'
          strokeWidth='0.5'
        />
        <path
          d='M15.5343 8.44459C15.741 8.65856 16.0207 8.77866 16.3123 8.77859C16.6039 8.77852 16.8836 8.65828 17.0902 8.44421L17.8679 7.63501L18.6456 8.44458C18.8528 8.65502 19.1314 8.77204 19.421 8.77026C19.7106 8.76848 19.9879 8.64804 20.1927 8.43507C20.3975 8.22209 20.5133 7.93375 20.515 7.63256C20.5167 7.33137 20.4042 7.04163 20.2018 6.82615L19.4234 6.01732L20.2018 5.20848C20.3042 5.10226 20.3854 4.9761 20.4409 4.8372C20.4964 4.6983 20.5249 4.54939 20.525 4.39899C20.5251 4.2486 20.4967 4.09966 20.4414 3.96069C20.3861 3.82173 20.305 3.69547 20.2027 3.58913C20.1004 3.4828 19.979 3.39847 19.8454 3.34098C19.7117 3.28349 19.5685 3.25396 19.4239 3.25408C19.2793 3.2542 19.1361 3.28396 19.0026 3.34167C18.869 3.39939 18.7477 3.48391 18.6456 3.59042L17.8679 4.39963L17.0902 3.59006C16.988 3.48358 16.8667 3.39908 16.7332 3.3414C16.5996 3.28372 16.4564 3.25399 16.3118 3.25391C16.1672 3.25382 16.024 3.28339 15.8904 3.34091C15.7568 3.39843 15.6354 3.48279 15.5331 3.58915C15.4309 3.69551 15.3498 3.82179 15.2945 3.96077C15.2392 4.09974 15.2108 4.24869 15.2109 4.39909C15.2111 4.54949 15.2397 4.69839 15.2952 4.83727C15.3507 4.97616 15.4319 5.1023 15.5343 5.20849L16.3124 6.01732L15.534 6.82616C15.3283 7.04114 15.2128 7.33214 15.2128 7.63545C15.2129 7.93877 15.3285 8.22971 15.5343 8.44459ZM16.0528 7.36539L17.0902 6.28692C17.1242 6.25152 17.1512 6.20949 17.1697 6.16323C17.1881 6.11697 17.1976 6.06738 17.1976 6.01731C17.1976 5.96723 17.1881 5.91765 17.1697 5.87139C17.1512 5.82513 17.1242 5.78309 17.0902 5.74769L16.0532 4.66923C15.985 4.59759 15.9469 4.5008 15.9472 4.40002C15.9474 4.29923 15.986 4.20265 16.0545 4.13136C16.123 4.06007 16.2158 4.01987 16.3127 4.01955C16.4097 4.01923 16.5027 4.05881 16.5717 4.12965L17.6087 5.20848C17.6787 5.27735 17.7715 5.31573 17.8679 5.31573C17.9643 5.31573 18.0571 5.27735 18.1272 5.20848L19.1641 4.13002C19.2334 4.0608 19.3259 4.02257 19.4219 4.02353C19.5179 4.0245 19.6098 4.06458 19.6777 4.13517C19.7456 4.20576 19.7842 4.30124 19.7852 4.4011C19.7862 4.50096 19.7495 4.59724 19.683 4.66926C18.1521 6.30609 18.1638 5.73516 19.683 7.36539C19.7512 7.43709 19.7893 7.53393 19.789 7.63476C19.7887 7.73558 19.7501 7.8322 19.6815 7.90349C19.613 7.97479 19.5201 8.01496 19.4231 8.01524C19.3262 8.01552 19.2331 7.97588 19.1641 7.90498L18.1271 6.82616C18.0571 6.75729 17.9643 6.71891 17.8679 6.71891C17.7715 6.71891 17.6787 6.75729 17.6086 6.82616L16.5717 7.90462C16.5024 7.97376 16.4099 8.01192 16.3139 8.01093C16.218 8.00993 16.1262 7.96986 16.0583 7.8993C15.9904 7.82874 15.9518 7.73332 15.9508 7.63351C15.9498 7.53369 15.9864 7.43744 16.0528 7.36539Z'
          fill='url(#paint4_linear_12280_31227)'
          stroke='url(#paint5_linear_12280_31227)'
          strokeWidth='0.5'
        />
        <path
          d='M6.13398 2.58203C5.84234 2.58236 5.56274 2.703 5.35652 2.91747C5.1503 3.13194 5.0343 3.42273 5.03398 3.72603V4.87003H3.93398C3.64225 4.87003 3.36246 4.99056 3.15617 5.2051C2.94988 5.41964 2.83398 5.71062 2.83398 6.01403C2.83398 6.31744 2.94988 6.60842 3.15617 6.82296C3.36246 7.0375 3.64225 7.15803 3.93398 7.15803H5.03398V8.30203C5.03398 8.60544 5.14988 8.89642 5.35617 9.11096C5.56246 9.3255 5.84225 9.44603 6.13398 9.44603C6.42572 9.44603 6.70551 9.3255 6.9118 9.11096C7.11809 8.89642 7.23398 8.60544 7.23398 8.30203V7.15803H8.33398C8.62572 7.15803 8.90551 7.0375 9.1118 6.82296C9.31809 6.60842 9.43398 6.31744 9.43398 6.01403C9.43398 5.71062 9.31809 5.41964 9.1118 5.2051C8.90551 4.99056 8.62572 4.87003 8.33398 4.87003H7.23398V3.72603C7.23367 3.42273 7.11767 3.13194 6.91145 2.91747C6.70523 2.703 6.42562 2.58236 6.13398 2.58203ZM8.33398 5.6327C8.42996 5.6347 8.52136 5.67575 8.58855 5.74705C8.65575 5.81835 8.69338 5.91421 8.69338 6.01404C8.69337 6.11388 8.65573 6.20973 8.58853 6.28103C8.52133 6.35232 8.42993 6.39337 8.33396 6.39536C6.13365 6.42925 6.53745 6.02855 6.50066 8.30203C6.49869 8.40181 6.45919 8.49682 6.39064 8.56666C6.32208 8.6365 6.22994 8.67562 6.13398 8.67561C6.03801 8.67561 5.94587 8.63648 5.87732 8.56664C5.80878 8.49679 5.76929 8.40178 5.76733 8.302C5.73453 6.01479 6.12083 6.43327 3.93398 6.39536C3.83804 6.39331 3.74669 6.35224 3.67953 6.28094C3.61238 6.20965 3.57477 6.11382 3.57477 6.01401C3.57478 5.91421 3.6124 5.81838 3.67956 5.7471C3.74672 5.67581 3.83807 5.63474 3.93402 5.6327C6.13142 5.59796 5.73142 6.00242 5.76732 3.72603C5.76929 3.62625 5.80879 3.53124 5.87734 3.4614C5.9459 3.39156 6.03804 3.35245 6.13401 3.35245C6.22997 3.35246 6.32211 3.39158 6.39066 3.46143C6.4592 3.53128 6.49869 3.62629 6.50065 3.72607C6.53424 6.01027 6.14441 5.59569 8.33398 5.6327Z'
          fill='url(#paint6_linear_12280_31227)'
          stroke='url(#paint7_linear_12280_31227)'
          strokeWidth='0.5'
        />
        <path
          d='M21.9 10.5904H13.4667V1.81978C13.4663 1.51648 13.3504 1.22569 13.1441 1.01122C12.9379 0.796747 12.6583 0.676112 12.3667 0.675781H11.6333C11.3417 0.676112 11.0621 0.796747 10.8559 1.01122C10.6496 1.22569 10.5337 1.51648 10.5333 1.81978V10.5904H2.1C1.80836 10.5908 1.52876 10.7114 1.32253 10.9259C1.11631 11.1404 1.00032 11.4311 1 11.7344V12.4971C1.00032 12.8004 1.11631 13.0912 1.32253 13.3057C1.52876 13.5201 1.80836 13.6408 2.1 13.6411H10.5333V22.4118C10.5337 22.7151 10.6496 23.0059 10.8559 23.2203C11.0621 23.4348 11.3417 23.5554 11.6333 23.5558H12.3667C12.6583 23.5554 12.9379 23.4348 13.1441 23.2203C13.3504 23.0059 13.4663 22.7151 13.4667 22.4118V13.6411H21.9C22.1916 13.6408 22.4712 13.5201 22.6775 13.3057C22.8837 13.0912 22.9997 12.8004 23 12.4971V11.7344C22.9997 11.4311 22.8837 11.1404 22.6775 10.9259C22.4712 10.7114 22.1916 10.5908 21.9 10.5904ZM22.2667 12.4971C22.2666 12.5982 22.2279 12.6952 22.1592 12.7667C22.0905 12.8382 21.9972 12.8784 21.9 12.8784H13.1C13.0518 12.8784 13.0041 12.8883 12.9597 12.9074C12.9152 12.9266 12.8747 12.9547 12.8407 12.9901C12.8066 13.0255 12.7796 13.0675 12.7612 13.1138C12.7428 13.1601 12.7333 13.2097 12.7333 13.2598V22.4118C12.7333 22.5129 12.6946 22.6098 12.6259 22.6813C12.5571 22.7528 12.4639 22.793 12.3667 22.7931H11.6333C11.5361 22.793 11.4429 22.7528 11.3741 22.6813C11.3054 22.6098 11.2667 22.5129 11.2667 22.4118V13.2598C11.2667 13.2097 11.2572 13.1601 11.2388 13.1138C11.2204 13.0675 11.1934 13.0255 11.1593 12.9901C11.1253 12.9547 11.0848 12.9266 11.0403 12.9074C10.9959 12.8883 10.9482 12.8784 10.9 12.8784H2.1C2.00277 12.8784 1.90955 12.8382 1.8408 12.7667C1.77205 12.6952 1.7334 12.5982 1.73333 12.4971V11.7344C1.7334 11.6333 1.77205 11.5364 1.8408 11.4649C1.90955 11.3934 2.00277 11.3532 2.1 11.3531H10.9C10.9482 11.3531 10.9959 11.3433 11.0403 11.3241C11.0848 11.305 11.1253 11.2769 11.1593 11.2415C11.1934 11.2061 11.2204 11.164 11.2388 11.1177C11.2572 11.0715 11.2667 11.0219 11.2667 10.9718V1.81978C11.2667 1.71867 11.3054 1.62171 11.3741 1.55021C11.4429 1.47871 11.5361 1.43852 11.6333 1.43845H12.3667C12.4639 1.43852 12.5571 1.47871 12.6259 1.55021C12.6946 1.62171 12.7333 1.71867 12.7333 1.81978V10.9718C12.7333 11.0219 12.7428 11.0715 12.7612 11.1177C12.7796 11.164 12.8066 11.2061 12.8407 11.2415C12.8747 11.2769 12.9152 11.305 12.9597 11.3241C13.0041 11.3433 13.0518 11.3531 13.1 11.3531H21.9C21.9972 11.3532 22.0905 11.3934 22.1592 11.4649C22.2279 11.5364 22.2666 11.6333 22.2667 11.7344V12.4971Z'
          fill='url(#paint8_linear_12280_31227)'
          stroke='url(#paint9_linear_12280_31227)'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_31227'
          x1='16.0695'
          y1='15.5875'
          x2='18.8363'
          y2='21.1698'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_31227'
          x1='16.0695'
          y1='15.5875'
          x2='18.8363'
          y2='21.1698'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_31227'
          x1='4.20846'
          y1='15.5521'
          x2='6.44967'
          y2='20.9092'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_31227'
          x1='4.20846'
          y1='15.5521'
          x2='6.44967'
          y2='20.9092'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_31227'
          x1='16.3114'
          y1='3.63063'
          x2='18.8873'
          y2='8.59668'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_31227'
          x1='16.3114'
          y1='3.63063'
          x2='18.8873'
          y2='8.59668'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_31227'
          x1='4.20069'
          y1='3.05008'
          x2='7.40173'
          y2='9.21909'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_31227'
          x1='4.20069'
          y1='3.05008'
          x2='7.40173'
          y2='9.21909'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_31227'
          x1='5.55569'
          y1='2.23594'
          x2='16.2258'
          y2='22.7993'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_31227'
          x1='5.55569'
          y1='2.23594'
          x2='16.2258'
          y2='22.7993'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_31227'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CrossPlus;
